<input type="checkbox" id="toggle-button-checkbox_{{toggleId}}"
  [checked]="enabled"
  [disabled]="disableInput"
  (change)="fieldsChange($event)"
/>

<label class="toggle-button-switch"
  for="toggle-button-checkbox_{{toggleId}}"></label>

<!-- Toggle con valori testuali -->
<div *ngIf="!useIcons" class="toggle-button text">
  <div class="toggle-button-on">{{'rules.enabled_turn_on' | translate}}</div>
  <div class="toggle-button-off">{{'rules.enabled_turn_off' | translate}}</div>
</div>

<!-- Toggle con icone -->
<div *ngIf="useIcons" class="toggle-button icons">
  <em [ngClass]="onIcon ? onIcon : 'icon-close'" class="toggle-button-on icon fa-2x" style="color: #fff;"></em>
  <em [ngClass]="offIcon ? offIcon : 'icon-close'" class="toggle-button-off icon fa-2x" style="color: #fff;"></em>
</div>

<div class="row">
  <div class="col-xl-12 col-lg-12">
  </div>
</div>
